import { useEffect, useState } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import CurrencySuggestion from "./CurrencySuggestion";
import { ArrowRight } from "lucide-react";
import { track } from "../lib/api";

export default function PublicLayout() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo(0, 0);
    }
    track("page_view");
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-navy">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CurrencySuggestion />
      {/* Sticky mobile CTA */}
      <div className="xl:hidden fixed bottom-0 inset-x-0 z-40 glass-header border-t border-white/10 px-4 py-3" data-testid="mobile-sticky-cta">
        <Link
          to="/get-estimate"
          data-testid="mobile-sticky-get-estimate-btn"
          onClick={() => track("estimate_click", { location: "mobile_sticky" })}
          className="flex items-center justify-center gap-2 w-full rounded-full bg-flame hover:bg-flame-hover text-white font-heading font-bold tracking-wide py-3.5 transition-colors"
        >
          GET ESTIMATE <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="xl:hidden h-16" />
    </div>
  );
}
